import clsx from 'clsx';
import React, {
  ButtonHTMLAttributes,
  FC,
  useEffect,
  useRef,
  useState,
} from 'react';

import BaseButton from '1_components/Buttons/BaseButton/BaseButton';
import useScriptStore from 'state/scriptStore';
import { useAudioStore } from 'state/sfx/audioStore';
import useSoundsPreloadStore from 'state/soundsPreloadStore';

import S from './ReportButton.module.scss';

export interface ReportButtonProps
  extends ButtonHTMLAttributes<HTMLButtonElement> {}

const ReportButton: FC<ReportButtonProps> = ({ onClick }) => {
  const reportMentioned = useScriptStore(s => s.reportMentioned);
  const [shine, setShine] = useState(false);

  const isAllowedAudio = useAudioStore(s => s.isAllowed);
  const audioRef = useRef<HTMLAudioElement | null>(null);
  const audioSrc = useSoundsPreloadStore(
    s => s.library?.['general_report_beacon']?.src
  );

  useEffect(() => {
    if (reportMentioned) {
      setShine(true);
    }
  }, [reportMentioned]);

  useEffect(() => {
    if (shine && audioRef.current) {
      audioRef.current.play();
    }
  }, [shine, audioRef]);

  return (
    <>
      {shine && <span className={S.ShineDroplet} />}

      <BaseButton
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        className={clsx(S.ReportButton, shine ? S.Shine : null)}
        onClick={onClick}
        onAnimationEnd={() => {
          setShine(false);
        }}
      >
        Read your report
      </BaseButton>

      <audio
        ref={audioRef}
        src={audioSrc}
        muted={!isAllowedAudio}
        preload="auto"
      />
    </>
  );
};
export default ReportButton;
